import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthPayload, AuthProfile, AuthToken, AuthUser, LoginResponse } from './auth.model';
import { of, Subject, tap } from 'rxjs';
import { PermissionService } from './permission.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http$ = inject(HttpClient);
  private permService = inject(PermissionService);
  private logout$ = new Subject<void>();
  private profileValue: AuthUser | null = null;
  private TOKEN_KEY = 'token';
  private USER_KEY = 'user';
  private REFRESH_TOKEN_KEY = 'refresh_token';

  login(payload: AuthPayload) {
    return this.http$.post<LoginResponse>(`/auth/login`, payload).pipe(
      tap((resp) => {
        this.setToken(resp.token)
        this.setUser(resp.user)
      })
    );
  }

  refreshToken() {
    return this.http$.get(`/auth/refresh-token`);
  }

  logout() {
    return this.http$.post('/auth/logout', {}).pipe(
      tap(() => {
        this.clearProfile();
      }),
    );
  }

  clearProfile() {
    this.profileValue = null;
    this.permService.loadRole('');
    this.logout$.next();
  }

  logoutValueChange() {
    return this.logout$.asObservable();
  }

  changePassword(payload: { username?: string; password: string; new_password: string }) {
    return this.http$.post('/auth/change_password', payload);
  }

  // profile() {
  //   if (this.profileValue !== null) {
  //     return of(this.profileValue);
  //   }
  //   return this.http$.get<AuthProfile>('/auth/profile').pipe(
  //     tap((resp) => {
  //       this.profileValue = resp;
  //       this.permService.loadRole(resp.role);
  //     }),
  //   );
  // }

  // ดึง token
  getToken(): AuthToken | null {
    const json = localStorage.getItem(this.TOKEN_KEY);
    return json ? JSON.parse(json) as AuthToken : null;
  }

  // เซต token
  setToken(token: AuthToken): void {
    localStorage.setItem(this.TOKEN_KEY, JSON.stringify(token));
  }

  // get user
  getUser(): AuthUser | null {
    const json = localStorage.getItem(this.USER_KEY);
    this.profileValue = json ? JSON.parse(json) as AuthUser : null;
    this.permService.loadRole(this.profileValue?.role_number ?? '');
    return json ? JSON.parse(json) as AuthUser : null;
  }

  // set user
  setUser(user: AuthUser): void {
    user = { ...user, is_set_password: true, role_name: user.role.name, role_number: user.role.role_number };
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
  }

  // ลบ token ทั้งหมด (ใช้เวลา logout หรือ refresh ล้มเหลว)
  clearToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
    localStorage.removeItem(this.USER_KEY);
  }

  getAccessToken(): string | null {
    return this.getToken()?.token ?? null;
  }

  // ถ้า API รองรับ refresh token
  setRefreshToken(refreshToken: string): void {
    localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }
}
